/**
 * mm-blog-grid.js
 * Ground Truth listing: featured lead, type chips, industry select, search, load older.
 */
(function () {
  const PARAM_Q = 'q';
  const PARAM_TYPE = 'type';
  const PARAM_VERT = 'vertical';

  function splitList(value) {
    return String(value || '')
      .split(',')
      .map(function (part) {
        return part.trim();
      })
      .filter(Boolean);
  }

  function wordsInHaystack(query, haystack) {
    const hay = String(haystack || '').toLowerCase();
    const words = String(query || '')
      .toLowerCase()
      .trim()
      .split(/\s+/)
      .filter(Boolean);
    if (!words.length) return true;
    return words.every(function (word) {
      return hay.indexOf(word) !== -1;
    });
  }

  class MmBlogGrid extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this._q = '';
      this._type = '';
      this._vert = '';
      this._pageSize = parseInt(this.dataset.pageSize, 10) || 9;
      this._shown = this._pageSize;
      this._cards = Array.from(this.querySelectorAll('[data-mm-card]'));
      this._order = this._cards.slice();
      this._qInput = this.querySelector('[data-mm-q]');
      this._qClear = this.querySelector('[data-mm-q-clear]');
      this._vertSelect = this.querySelector('[data-mm-vertical]');
      this._typeButtons = Array.from(this.querySelectorAll('[data-mm-type]'));
      this._countEl = this.querySelector('[data-mm-count]');
      this._resetEl = this.querySelector('[data-mm-reset]');
      this._emptyEl = this.querySelector('[data-mm-empty]');
      this._gridEl = this.querySelector('[data-mm-grid]');
      this._leadEl = this.querySelector('[data-mm-lead]');
      this._loadEl = this.querySelector('[data-mm-load]');
      this._moreBtn = this.querySelector('[data-mm-more]');
      this._onQInput = this._handleQInput.bind(this);
      this._onQClear = this._clearQuery.bind(this);
      this._onVert = this._handleVert.bind(this);
      this._onReset = this._resetAll.bind(this);
      this._onTypeClick = this._handleTypeClick.bind(this);
      this._onMore = this._loadOlder.bind(this);
      this._readUrl();
      this._bind();
      this._apply(true);
    }

    disconnectedCallback() {
      this._qInput?.removeEventListener('input', this._onQInput);
      this._qClear?.removeEventListener('click', this._onQClear);
      this._vertSelect?.removeEventListener('change', this._onVert);
      this._resetEl?.removeEventListener('click', this._onReset);
      this._typeButtons.forEach((btn) => {
        btn.removeEventListener('click', this._onTypeClick);
      });
      this._moreBtn?.removeEventListener('click', this._onMore);
      if (this._timer) window.clearTimeout(this._timer);
    }

    _bind() {
      this._qInput?.addEventListener('input', this._onQInput);
      this._qClear?.addEventListener('click', this._onQClear);
      this._vertSelect?.addEventListener('change', this._onVert);
      this._resetEl?.addEventListener('click', this._onReset);
      this._typeButtons.forEach((btn) => {
        btn.addEventListener('click', this._onTypeClick);
      });
      this._moreBtn?.addEventListener('click', this._onMore);
    }

    _readUrl() {
      const params = new URLSearchParams(window.location.search);
      this._q = (params.get(PARAM_Q) || '').trim();
      this._type = (params.get(PARAM_TYPE) || '').trim();
      this._vert = (params.get(PARAM_VERT) || '').trim();
      const types = this._typeButtons.map(function (btn) {
        return btn.getAttribute('data-mm-type') || '';
      });
      if (this._type && types.indexOf(this._type) === -1) this._type = '';
      if (this._vertSelect) {
        const allowed = Array.from(this._vertSelect.options).map(function (opt) {
          return opt.value;
        });
        if (this._vert && allowed.indexOf(this._vert) === -1) this._vert = '';
        this._vertSelect.value = this._vert;
      }
      if (this._qInput) this._qInput.value = this._q;
    }

    _writeUrl() {
      const url = new URL(window.location.href);
      if (this._q) url.searchParams.set(PARAM_Q, this._q);
      else url.searchParams.delete(PARAM_Q);
      if (this._type) url.searchParams.set(PARAM_TYPE, this._type);
      else url.searchParams.delete(PARAM_TYPE);
      if (this._vert) url.searchParams.set(PARAM_VERT, this._vert);
      else url.searchParams.delete(PARAM_VERT);
      url.searchParams.delete('page');
      const next = url.pathname + url.search + url.hash;
      const current = window.location.pathname + window.location.search + window.location.hash;
      if (next !== current) history.replaceState(null, '', next);
    }

    _handleQInput() {
      const value = (this._qInput?.value || '').trim();
      if (this._timer) window.clearTimeout(this._timer);
      this._timer = window.setTimeout(() => {
        this._q = value;
        this._shown = this._pageSize;
        this._apply();
      }, 120);
    }

    _clearQuery() {
      this._q = '';
      if (this._qInput) this._qInput.value = '';
      this._shown = this._pageSize;
      this._apply();
      this._qInput?.focus();
    }

    _handleVert() {
      this._vert = this._vertSelect?.value || '';
      this._shown = this._pageSize;
      this._apply();
    }

    _handleTypeClick(event) {
      const btn = event.currentTarget;
      this._type = btn.getAttribute('data-mm-type') || '';
      this._shown = this._pageSize;
      this._apply();
    }

    _resetAll() {
      this._q = '';
      this._type = '';
      this._vert = '';
      this._shown = this._pageSize;
      if (this._qInput) this._qInput.value = '';
      if (this._vertSelect) this._vertSelect.value = '';
      this._apply();
    }

    _loadOlder() {
      this._shown += this._pageSize;
      this._apply(true);
    }

    _insertInOrder(card) {
      if (!this._gridEl) return;
      const index = this._order.indexOf(card);
      let before = null;
      for (let i = index + 1; i < this._order.length; i += 1) {
        if (this._order[i].parentNode === this._gridEl) {
          before = this._order[i];
          break;
        }
      }
      if (before) this._gridEl.insertBefore(card, before);
      else this._gridEl.appendChild(card);
    }

    _syncLead(matched) {
      const want = matched[0] || null;
      const current = this._leadEl?.querySelector('[data-mm-card]') || null;
      if (current && current !== want) {
        current.classList.remove('mm-bgrid__card--lead');
        this._insertInOrder(current);
      }
      if (!this._leadEl) return matched;
      if (!want) {
        this._leadEl.hidden = true;
        return matched;
      }
      want.classList.add('mm-bgrid__card--lead');
      want.hidden = false;
      if (want.parentNode !== this._leadEl) this._leadEl.appendChild(want);
      this._leadEl.hidden = false;
      return matched.slice(1);
    }

    _matches(card) {
      if (this._type) {
        const types = splitList(card.dataset.mmTypes);
        if (types.indexOf(this._type) === -1) return false;
      }
      if (this._vert) {
        const verts = splitList(card.dataset.mmVerticals);
        if (verts.indexOf(this._vert) === -1) return false;
      }
      return wordsInHaystack(this._q, card.dataset.mmSearch);
    }

    _apply(fromUrl) {
      const matched = this._order.filter((card) => this._matches(card));
      const total = this._order.length;
      const count = matched.length;
      const rest = this._syncLead(matched);
      const visible = rest.slice(0, this._shown);

      this._order.forEach((card) => {
        if (card.classList.contains('mm-bgrid__card--lead')) return;
        card.hidden = true;
      });
      visible.forEach((card) => {
        card.hidden = false;
      });

      if (this._gridEl) this._gridEl.hidden = visible.length === 0;
      if (this._emptyEl) this._emptyEl.hidden = count !== 0;
      if (this._loadEl) this._loadEl.hidden = visible.length >= rest.length;

      this._typeButtons.forEach((btn) => {
        const value = btn.getAttribute('data-mm-type') || '';
        btn.setAttribute('aria-pressed', String(value === this._type));
      });

      if (this._qClear) this._qClear.hidden = !this._q;
      const filtered = Boolean(this._q || this._type || this._vert);
      if (this._resetEl) this._resetEl.hidden = !filtered;

      if (this._countEl) {
        if (!count) this._countEl.textContent = '';
        else if (filtered) this._countEl.textContent = count + ' of ' + total + ' articles';
        else this._countEl.textContent = count + ' articles';
      }

      if (!fromUrl) this._writeUrl();
    }
  }

  if (!customElements.get('mm-blog-grid')) {
    customElements.define('mm-blog-grid', MmBlogGrid);
  }
})();
